import { ReactNode } from 'react';
import { Card } from '../atoms/Card';
import { Title } from '../atoms/Title';
import { Link, LinkProps } from '../atoms/Link';
import { mapToBackgroundClass } from '../../../lib/backgroundColorMapping';
import { mapToTextClass } from '../../../lib/textColorMapping';
import { ColorOptions } from '../../../types/colorOptions';
import { SimpleReactComponentProps } from '../../../types/components';

const defaultClass = 'flex flex-col w-64 h-72 rounded-2xs p-5 text-center';
const defaultButtonClass =
	'px-4 py-2.5 mt-auto self-center rounded-2xs cursor-pointer text-sm bg-white';

export interface ContactCardProps extends SimpleReactComponentProps {
	title: string;
	icon?: ReactNode;
	summary?: ReactNode;
	link: LinkProps;
	linkColorOptions: ColorOptions;
	colorOptions?: ColorOptions;
}

const getClass = (colorOptions?: ColorOptions, classOverrides?: string) => {
	if (classOverrides) {
		return classOverrides;
	}

	return `${defaultClass} ${mapToTextClass(
		colorOptions?.fontColor,
	)} ${mapToBackgroundClass(colorOptions?.backgroundColor)}`;
};

const getLinkButtonClass = (colorOptions?: ColorOptions) => {
	return `${defaultButtonClass}  ${mapToBackgroundClass(colorOptions?.backgroundColor)} text-primary-teal`;

	//TODO: restore if we want to use color options for buttons or refactor/remove

	// ${
	// 	mapToTextClass(
	// 	colorOptions?.fontColor,
	// )}
};
export const ContactCard = ({
	title,
	icon,
	summary,
	link: { label: ctaLabel, url: ctaUrl },
	classOverrides,
	linkColorOptions,
	colorOptions,
}: ContactCardProps) => {
	return (
		<Card className={getClass(colorOptions, classOverrides)}>
			{icon && (
				<span className={`${typeof icon === 'string' ? icon : ''} text-[40px]`}>
					{}
				</span>
			)}
			<Title
				title={title}
				style={'text-lg'}
				classOverrides="text-base font-bold mt-4"
			/>
			{summary && summary}
			{ctaLabel && ctaUrl && (
				<Link
					label={ctaLabel}
					url={ctaUrl}
					className={getLinkButtonClass(linkColorOptions)}
				/>
			)}
		</Card>
	);
};
